<script>
export default {
    name: 'SearchSuggestionsPosts',
    inject: ['$t'],
    props: {
        posts: {
            type: Array,
            required: true
        }
    },
    methods: {
        getPostUrl(post) {
            return `${window.BASE_URL}${post.link}`;
        }
    }
};
</script>

<template>
    <div v-if="posts.length">
        <div class="text-md-v4 mb-4 font-bold">
            {{ $t('postsTitle') }}
        </div>
        <ul>
            <li v-for="(item, key) in posts" :key="key" class="mb-2 last:mb-0">
                <div
                    class="h-31 shadow-base rounded-block mb-4 flex items-center bg-white last:mb-0 lg:overflow-hidden"
                >
                    <a
                        :href="getPostUrl(item)"
                        class="w-22.5 rounded-l-block h-full shrink-0 overflow-hidden"
                    >
                        <img
                            class="h-31 -ml-[25%] max-w-none"
                            :src="item.img"
                            :alt="item.title"
                        />
                    </a>
                    <div class="p-2 lg:p-6">
                        <a :href="getPostUrl(item)">
                            <div class="text-sl-v3 font-bold">
                                {{ item.title }}
                            </div>
                        </a>
                        <div
                            class="text-xsl-v3 mb-3 h-[29px] w-full overflow-hidden"
                        >
                            <span v-html="item.description"></span>
                        </div>
                        <a
                            class="text-xsl"
                            :href="getPostUrl(item)"
                            :title="$t('readMore')"
                        >
                            {{ $t('readMore') }}
                            <span>...</span>
                        </a>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
